import {Routes} from '@angular/router';
import {RoomsListComponent} from '@pages/support/rooms-list/rooms-list.component';
import {SupportStreamingComponent} from '@pages/support/support-streaming/support-streaming.component';

export const SUPPORT_ROUTES: Routes = [
  {
    path: 'room/list',
    component: RoomsListComponent,
    data: {
      title: 'Stanze',
      titleKey: 'menu.rooms',
      urls: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Support' },
      ],
    }
  },
  {
    path: 'room/:uuid',
    component: SupportStreamingComponent,
    data: {
      // Changing room from the sidebar must close the call and the archive of the previous room and open new ones
      recreateOnParamChange: true,
      title: 'Videochiamata',
      titleKey: 'call.page_title',
      urls: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Room List', url: '/support/room/list' },
        { title: 'Support' },
      ],
    }
  }
];
